import React from "react";
import { Button, Col, Result } from "antd";
import { MetaTags } from "react-meta-tags";
import development from "../../assets/images/under-development/4819.jpg";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
const NotFound = () => {
  return (
    <React.Fragment>
      <MetaTags>
        <title>Not found | Plan Mi Trip</title>
      </MetaTags>
      <Col 
      ></Col>
      <Result
        status='404'
        // title='404'
        icon={development}
        style={{
          fontFamily: "Poppins",
        }}
        subTitle="Sorry, the page you visited, under development"
        extra={
          <Button
            style={{
              fontFamily: "Poppins",
              borderRadius: "4px",
              fontFamily: "Poppins",
              background: "#eb3e43",
              fontEeight: 800,
              color: "white",
              cursor: "pointer",
            }}
            type="primary"
            className="hover hover:text-[white]"
            href="/"
          >
            Back Home
          </Button>
        }
      />
    </React.Fragment>
  );
};

NotFound.propTypes = {
  location: PropTypes.any,
};

export default withRouter(NotFound);
